export const TAG_MANAGER_ID: string = process.env.VITE_GTM_SITE_KEY ?? '';
export const TAG_MANAGER_ENV: string = process.env.VITE_GTM_ENV ?? '';
export const TAG_MANAGER_AUTH: string = process.env.VITE_GTM_AUTH ?? '';

export const EVENT_SEPARATOR = ' - ';

export const PROJECT_EVENT_TAG = 'EB Portal';

export const CLICK_ACTION = 'Click';
export const ERROR_ACTION = 'Error';
export const RESET_VARIABLES = 'ResetVariables';
export const SET_ACTION = 'Set';

export const USER_ATTRIBUTES_IDENTIFIER = 'csp-';

export const LOGIN = 'Login';
export const FORGOT_PASSWORD_PAGE = 'ForgotPassword';
export const LOGOUT = 'Logout';

export const SCHEDULE_INTERVIEW = 'ScheduleInterview';
export const SCHEDULE_INTERVIEW_CANCEL = 'ScheduleInterviewCancel';

export const COLLABORATORS_ENTERPRISE = 'CollaboratorsEnterpriseDropdown';
export const PAGINATOR_JUMP_TO_PAGE = 'PaginatorJumpToPage';
export const COLLABORATORS_TABS = 'CollaboratorSection';
export const SEND_REQUEST = 'SendRequest';
export const COLLABORATORS_MANAGEMENT_ERROR_FILE = 'CollaboratorsFile';
export const SEARCH_COLLABORATORS = 'SearchCollaborators';
export const SELECT_LANGUAGE = 'SelectLanguage';
export const SIDEBAR_SECTION = 'SideBarSection';
export const GO_TO_SECTION = 'GoToSection';
export const MAIN_BANNER = 'Banner';
export const QUICK_ACCESS = 'QuickAccess';
export const DATE_CALENDAR = 'DateCalendar';
export const EVENT_CALENDAR = 'EventCalendar';
export const CTA_CALENDAR = 'CTACalendar';
export const MONTH_CALENDAR = 'MonthCalendar';
export const FILTERED_COLLABORATORS = 'FilterCollaborators';
export const ADMIN_PROPERTIES = 'AdminProperties';
export const SHOW_MORE = 'ShowMore';
export const CHANGE_PASSWORD = 'ChangePassword';
export const PROFILE_SECTION = 'ProfileSection';
export const PROFILE_DROPDOWN = 'ProfileDropdown';
export const UPLOAD_PICTURE = 'UploadPicture';
export const DELETE_PICTURE = 'DeletePicture';
export const SAVE_CHANGES = 'SaveChanges';
export const HOLDINGS_DROPDOWN = 'HoldingsDropdown';
export const EDIT_HOLDING = 'EditHolding';
export const EDIT_COMPANY = 'EditCompany';
export const CONFIGURATION_SECTION = 'ConfigurationSection';
export const NEW_STORY = 'NewStory';
export const STORY_SECTION = 'StorySection';
export const STORY_FILTER_DROPDOWN = 'StoryFilterDropdown';
export const SEE_DETAILS_STORY = 'SeeDetailsStory';
export const DUPLICATE_STORY = 'DuplicateStory';
export const HIDE_STORY = 'HideStory';
export const CONTINUE = 'Continue';
export const DELETE_STORY = 'DeleteStory';
export const CANCEL_DELETE_STORY = 'CancelDeleteStory';
export const CANCEL_CREATE_STORY = 'CancelCreateStory';
export const CREATE_STORY = 'CreateStory';
export const CANCEL_POST_STORY = 'CancelPostStory';
export const POST_STORY = 'PostStory';
export const CREATE_ACCOUNT = 'CreateAccount';
export const INVITE_COLLABORATORS_EMAILS = 'InviteCollaboratorsEmailList';
export const INVITE_COLLABORATORS_DOMAINS = 'InviteCollaboratorsSetCompanyDomain';
export const INVITE_COLLABORATORS_FILE = 'InviteCollaboratorsByFile';
export const INVITE_COLLABORATORS_METHOD = 'InviteCollaboratorsMethod';
export const INVITE_COLLABORATORS_METHOD_BACK = 'InviteCollaboratorsMethodBack';
export const INVITE_COLLABORATORS_CONNECT_SLACK = 'InviteCollaboratorsConnectSlack';
export const INVITE_COLLABORATORS_CONNECT_SLACK_LATER = 'InviteCollaboratorsSlackConnectLater';
export const LOAD_BALANCE = 'LoadBalance';
export const SELECT_COLLABORATORS_POINTS_FILTER = 'SelectCollaboratorsPointsFilter';
export const SAVE_PEOPLE_RECEIVE_POINTS = 'SavePeopleReceivePoints';
export const LOAD_BALANCE_ALERT = 'LoadBalanceAlert';
export const CHANGE_COLLABORATORS_LIST_POINTS = 'ChangeCollaboratorsListPoints';
export const GO_TO_ORDER_HISTORY = 'GoToOrderHistory';
export const SEND_MORE_POINTS = 'SendMorePoints';
export const CONFIRM_LOAD = 'ConfirmLoad';
export const MORE_LOAD = 'MoreLoad';
export const REWARDS_HISTORY_SECTION = 'RewardsHistorySection';
export const ORDER_HISTORY_FILTER_DROPDOWN = 'OrderHistoryFilterDropdown';
export const ORDER_HISTORY_RELOAD = 'OrderHistoryReload';
export const ORDER_DETAIL = 'OrderDetail';
export const COLLABORATOR_ORDER_DROPDOWN = 'CollaboratorOrderDropdown';
export const SELECT_HABIT_DROPDOWN = 'SelectHabitDropdown';
export const SEE_ALL_CAUSES = 'SeeAllCauses';
export const SELECT_COLLABORATORS_POINTS_METHODS = 'SelectCollaboratorsPointsMethods';
export const DOWNLOAD_COLLABORATORS_POINTS_TEMPLATE = 'DownloadCollaboratorPointsTemplate';
export const POINTS_DOWNLOAD_COLLABORATORS_FILE_ERRORS_AND_CONTINUE =
  'PointsDownloadCollaboratorsFileErrorsAndContinue';
export const POINTS_DOWNLOAD_COLLABORATORS_FILE_LATER = 'PointsCollaboratorsFileLater';
export const POINTS_DOWNLOAD_COLLABORATORS_FILE_ERRORS = 'PointsDownloadCollaboratorsFileErrors';
export const POINTS_FILE_SKIP_AND_END = 'PointsFileSkipAndEnd';
export const POINTS_REWARDS_MISSING_COLLABORATORS_FILE = 'RewardsMissingCollaboratorsFile';
export const SELECT_RANKING_CATEGORY = 'SelectRankingCategory';
export const SECTION_ACCESS = 'SectionAccess';
export const SWITCH_BANNER = 'SwitchBanner';
export const SELECT_TAB = 'SelectTab';
export const CREATE_CHALLENGE = 'CreateChallenge';
export const CHALLENGE_DETAIL = 'ChallengeDetail';
export const COLLABORATOR_DETAIL = 'CollaboratorDetail';
export const CREATE_CHALLENGE_CHOOSE_TYPE = 'CreateChallengeChooseType';
export const CREATE_CHALLENGE_SELECT_DATES = 'CreateChallengeChooseDates';
export const CREATE_CHALLENGE_GOAL = 'CreateChallengeSetGoal';
export const CREATE_CHALLENGE_TITLE = 'CreateChallengeSetTitle';
export const CREATE_CHALLENGE_SUCCESS = 'CreateChallengeSuccess';
export const CREATE_CHALLENGE_CONFIRM = 'CreateChallengeConfirm';
export const CREATE_CHALLENGE_ERROR = 'CreateChallengeError';
export const DELETE_CHALLENGE = 'DeleteChallenge';
export const DELETE_CHALLENGE_CONFIRM = 'DeleteChallengeConfirm';
export const DELETE_CHALLENGE_CANCEL = 'DeleteChallengeCancel';
export const DELETE_CHALLENGE_SUCCESS = 'DeleteChallengeSuccess';
export const DELETE_CHALLENGE_ERROR = 'DeleteChallengeError';
export const DELETE_COLLABORATOR = 'RemoveCollaborator';
export const RESEND_EMAIL = 'CollaboratorSendEmail';
export const CONFIRM_DELETE_COLLABORATOR = 'ConfirmRemoveCollaborator';
export const CANCEL_DELETE_COLLABORATOR = 'CancelRemoveCollaborator';
export const GO_TO_METRICS = 'GoToMetrics';
export const REQUEST_COLLABORATOR_LIST = 'RequestCollaboratorList';
export const ADD_COLLABORATORS = 'AddCollaborators';
export const MANAGE_COLLABORATORS = 'ManageCollaborators';
export const MANAGE_COLLABORATORS_SELECTION = 'ManageCollaboratorsSelection';
export const REMOVE_COLLABORATORS = 'RemoveCollaborators';
export const REMOVE_COLLABORATORS_CONFIRM = 'RemoveCollaboratorsConfirm';
export const REMOVE_COLLABORATORS_CANCEL = 'RemoveCollaboratorsCancel';
export const MANAGE_COLLABORATORS_SELECT_PLAN = 'InviteCollaboratorsPlanSelector';
export const INVITE_COLLABORATORS_CONFIRM_NEW_RECORDS = 'InviteCollaboratorsConfirmNewRecords';
export const MANAGE_COLLABORATORS_CHECKOUT = 'InviteCollaboratorsCheckOut';
export const MANAGE_COLLABORATORS_CHECKOUT_UPSELLING = 'UpsellingLicense';
export const INVITE_COLLABORATORS_SUCCESS = 'InviteCollaboratorsSuccess';
export const COLLABORATOR_BENEFIT_DETAIL_STATUS_DETAIL = 'CollaboratorBenefitDetailStatusDetail';
export const COLLABORATOR_BENEFIT_DETAIL_MY_PLAN_DETAIL = 'CollaboratorBenefitDetailMyPlanDetail';
export const COLLABORATOR_BENEFIT_DETAIL_EDIT_RF = 'CollaboratorBenefitDetailEditRF';
export const COLLABORATOR_BENEFIT_DETAIL_CONFIRM_EDIT_RF = 'CollaboratorBenefitDetailConfirmEditRF';
export const SELECT_PLAN_DETAIL = 'SelectPlanDetail';
export const MY_PLAN_HEALTH_BENEFIT_DETAIL = 'MyPlanHealthBenefitDetail';
export const DOWNLOAD_POLICY = 'DownloadPolicy';
export const REQUEST_UPSELLING = 'RequestUpselling';
export const CONFIRM_UPSELLING = 'ConfirmUpselling';
export const WELLBEING_BENEFIT_FILTER = 'WellbeingBenefitFilter';
export const WELLBEING_BENEFIT_DETAIL = 'WellbeingBenefitDetail';
export const SELECTED_BENEFITS_DETAIL = 'SelectedBenefitsDetail';
export const RECHARGE_BALANCE_RF = 'RechargeBalanceRF';
export const CONFIRM_RECHARGE_BALANCE_RF = 'ConfirmRechargeBalanceRF';
export const CONFIRM_TRANSFER_RF = 'ConfirmTransferRF';
export const COPY_BETTERFLY_ACCOUNT_RF = 'CopyBetterflyAccountRF';
export const SELECT_TAB_RF = 'SelectTabRF';
export const GO_TO_REPORTS = 'GoToReports';
export const DOWNLOAD_REPORT = 'DownloadReport';
export const INVITE_FAMILY_CONFIRM_NEW_RECORDS = 'InviteFamilyConfirmNewRecords';
export const INVITE_FAMILY_SUCCESS = 'InviteFamilySuccess';
export const FAMILY_FILE = 'FamilyFile';
export const DOWNLOAD_NOVATION = 'DownloadNovation';
export const REPORTS_TABS_TAG = 'ReportsTabs';
export const VIEW_HEALTH_REPORT = 'ViewHealthReport';
export const THUMBS_UP = 'ThumbsUp';
export const THUMBS_DOWN = 'ThumbsDown';
export const DETAIL_REQUESTS = 'DetailRequests';
export const GO_TO_HELP_CENTER = 'GoToHelpCenter';
export const SPLIT_EQUAL_AMOUNT = 'SplitEqualAmount';
export const CONFIRM_TRAINING = 'ConfirmTraining';
export const REJECT_TRAINING = 'RejectTraining';
export const RECONFIRM_TRAINING = 'ReConfirmTraining';
export const REREJECT_TRAINING = 'ReRejectTraining';
export const CANCEL_TRAINING = 'CancelTraining';
export const RECANCEL_TRAINING = 'ReCancelTraining';
export const CONFIRM_INSURANCE = 'ConfirmInsurance';
export const REJECT_INSURANCE = 'RejectInsurance';
export const RECONFIRM_INSURANCE = 'ReConfirmInsurance';
export const REREJECT_INSURANCE = 'ReRejectInsurance';
export const CANCEL_INSURANCE = 'CancelInsurance';
export const RECANCEL_INSURANCE = 'ReCancelInsurance';
export const HEALTH_REPORT_INSURANCE_USAGE = 'HealthReportInsuranceUsage';
export const HEALTH_REPORT_HABITS_AND_BENEFITS = 'HealthReportHabitsAndBenefits';
export const HEALTH_REPORT_COMMUNITY_AND_IMPACT = 'HealthReportCommunityAndImpact';
export const DOWNLOAD_HEALTH_REPORT = 'DownloadHealthReport';
export const DOWNLOAD_CERTIFICATE = 'DownloadCertificate';
export const FILTER_REQUESTS = 'FilterRequests';
export const PASSWORD_CONTINUE = 'PasswordContinue';
export const ASSOCIATED_METHOD = 'AssociatedMethod';
export const CONTINUE_CODE_VERIFICATION = 'ContinueCodeVerification';
export const RESEND_CODE_VERIFICATION = 'ResendCodeVerification';
export const RESTORE_PASSWORD = 'RestorePassword';
export const CREATE_PASSWORD = 'CreatePassword';
export const ENTER_EMAIL = 'EnterEmail';
export const COLLABORATOR_TABS = 'CollaboratorTabs';

export const IDENTIFY_EVENT = 'Identify';
export const TIME_FRAME_METRICS = 'TimeFrameMetrics';

export const SECTION_HOME = { section: 'home' };
export const SECTION_COLLABORATORS = { section: 'collaborators' };
export const MANAGE_COLLABORATORS_SECTION = { section: 'manage_collaborators' };
export const SECTION_BENEFITS = { section: 'benefits' };
export const SECTION_METRICS_V3 = { section: 'metrics' };
export const SECTION_CONFIGURATION = { section: 'configuration' };
export const SECTION_EXIT = { section: 'exit' };
export const SECTION_PLAN = { section: 'plan' };
export const SECTION_COMMUNICATIONS = { section: 'comunicate-story' };
export const SECTION_STORIES = { section: 'stories' };
export const SECTION_STORIES_NEW = { section: 'stories_new' };
export const SECTION_REWARDS = { section: 'rewards' };
export const SECTION_REWARDS_LOAD_BALANCE = { section: 'rewards-saldo' };
export const SECTION_REWARDS_POINTS = { section: 'rewards-points' };
export const SECTION_REWARDS_POINTS_FILE = { section: 'rewards-points-by-file' };
export const SECTION_COLLABORATOR_INVITE_EMAIL = { section: 'copy-paste' };
export const SECTION_COLLABORATOR_INVITE_FILE = { section: 'by-file' };
export const SECTION_COLLABORATOR_INVITE_DOMAIN = { section: 'company-domain' };
export const SECTION_REWARDS_HISTORY_DETAILS_REQUEST = { section: 'rewards_history_details' };
export const SECTION_REWARDS_HISTORY = { section: 'rewards-historic' };
export const SECTION_REWARDS_SEND_POINTS = { section: 'rewards_sendpoints' };
export const SECTION_REWARDS_SEND_POINTS_FILE = { section: 'rewards_sendpointsfile' };
export const SECTION_BALANCE_LOADS = { section: 'balance_loads' };
export const SECTION_POINTS = { section: 'points' };
export const SECTION_STEPS = { section: 'steps' };
export const SECTION_MEDITATION = { section: 'meditation' };
export const SECTION_EXERCISES = { section: 'exercises' };
export const SECTION_ACCOUNT = { section: 'account' };
export const SECTION_ORGANIZATION = { section: 'organization' };
export const SECTION_INTEGRATIONS = { section: 'integrations' };
export const SECTION_LANGUAGE = { section: 'language' };
export const SECTION_CHALLENGES = { section: 'challenges' };
export const SECTION_COLLABORATOR_DETAIL = { section: 'collaborator-detail' };
export const SECTION_COLLABORATOR_TABLE = { section: 'collaborator-table' };
export const SECTION_REQUESTS = { section: 'requests' };
export const SECTION_CREATE_ACCOUNT = { section: 'create-account' };
export const SECTION_FORGOT_PASSWORD = { section: 'forgot-password' };

export const SECTIONS_ALL = { section: 'Todas' };
export const SECTIONS_IMAGES = { section: 'Imagenes' };
export const SECTIONS_VIDEOS = { section: 'Videos' };

export const SECTIONS_REWARDS_HISTORY_POINTS = { section: 'history-points' };
export const SECTIONS_REWARDS_HISTORY_BALANCE = { section: 'history-balance' };

export const SECTION_BALANCE_SUMMARY = { section: 'balance_summary' };
export const SECTION_BALANCE_PER_CATEGORY = { section: 'balance_per_category' };

export const SUB_SECTION_PLAN = { subsection: 'plan' };
export const SUB_SECTION_ORGANIZATION = { subsection: 'organization' };
export const SUB_SECTION_PROFILE = { subsection: 'profile' };
export const SUB_SECTION_INTEGRATIONS = { subsection: 'integrations' };
export const SUB_SECTION_ACCOUNT = { subsection: 'account' };
export const SUB_SECTION_PASS_REQUEST = { subsection: 'request' };
export const SUB_SECTION_PASS_CONFIRM = { subsection: 'confirm' };
export const SUB_SECTION_PASS_CANCEL = { subsection: 'cancel' };
export const SUB_SECTION_MONTHLY_REPORTS = { subsection: 'monthly-report' };
export const SUB_SECTION_PAYROLL_REPORTS = { subsection: 'payroll-rf' };

export const SETTINGS_TABS_DICT: { [key: number]: { subsection: string } } = {
  0: SUB_SECTION_ORGANIZATION,
  1: SUB_SECTION_PLAN,
  2: SUB_SECTION_PROFILE,
  3: SUB_SECTION_INTEGRATIONS,
  4: SUB_SECTION_ACCOUNT
};

export const REWARDS_POINTS_TABS_DICT: { [key: number]: { section: string } } = {
  0: SECTION_REWARDS_POINTS_FILE,
  1: SECTION_REWARDS_POINTS
};

export const TARGET_TWITTER = { target: 'Twitter' };
export const TARGET_FACEBOOK = { target: 'Facebook' };
export const TARGET_LINKEDIN = { target: 'Linkedin' };
export const TARGET_PREVIEW = { target: 'Preview' };

export const STATE_SUCCESSFUL = { state: 'successful' };
export const STATE_ERROR = { state: 'error' };
export const FILTER_ALL = { filter: 'all' };
export const FILTER_ACTIVE = { filter: 'active' };
export const FILTER_INVITED = { filter: 'invited' };
export const FILTER_IN_PROGRESS = { filter: 'in progress' };
export const FILTER_SENDED = { filter: 'sended' };
export const FILTER_SENT = { filter: 'sent' };
export const FILTER_RECEIVED = { filter: 'received' };
export const FILTER_VOIDED = { filter: 'voided' };
export const FILTER_FAILED = { filter: 'failed' };
export const FILTER_APPROVED = { filter: 'approved' };
export const FILTER_REJECTED = { filter: 'rejected' };
export const FILTER_CURRENT_PAGE = { filter: 'current_page' };
export const FILTER_CURRENT_MONTH = { filter: 'current_month' };
export const FILTER_LAST_3_MONTHS = { filter: 'last_3_months' };
export const FILTER_LAST_12_MONTHS = { filter: 'last_12_months' };

export const TIMER_SELECTOR_FILTER_DICT: { [key: string]: { filter: string } } = {
  selectedMonth: FILTER_CURRENT_MONTH,
  lastThreeMonths: FILTER_LAST_3_MONTHS,
  lastTwelveMonths: FILTER_LAST_12_MONTHS
};

export const CATEGORY_ALL = { category: 'all' };
export const CATEGORY_VISIBLE = { category: 'visible' };
export const CATEGORY_HIDDEN = { category: 'hidden' };
export const CATEGORY_SCHEDULED = { category: 'scheduled' };
export const CATEGORY_PERMANENT = { category: 'permanent' };

export const SALE_BANNER_TYPE = 'sales_banners';
export const SHOW_ALL = { show: 'all' };
export const SCREEN_STORY_DETAIL = { screen: 'story-detail' };
export const SCREEN_HOME = { screen: 'home' };
export const SCREEN_COLLABORATORS = { screen: 'collaborators' };
export const SCREEN_MY_PLANS = { screen: 'my_plan' };
export const SCREEN_BENEFITS_DETAIL = { screen: 'benefit_detail' };

export const GOOGLE_PROVIDER = 'google';
export const MICROSOFT_PROVIDER = 'microsoft';
export const CLIENTS_PORTAL_PROVIDER = 'credentials';

export const PAYMENT_TYPE_BANK_TRANSFER = { payment_type: 'bank_transfer' };
export const PAYMENT_TYPE_CREDIT_LINE = { payment_type: 'credit_line' };

export const INVITE_COLLABORATORS_METRICS_ID = 'metrics-invite-collaborator';
export const COLLABORATORS_SYNC_METRICS_ID = 'metrics-collaborator-sync';
export const SOCIAL_CAUSES_METRICS_ID = 'metrics-social-causes';

export const QUICK_ACCESS_COLLABORATORS = 'quick-access-collaborators';
export const QUICK_ACCESS_PLAN = 'quick-access-plan';
export const QUICK_ACCESS_PAYMENT = 'quick-access-payment';
export const QUICK_ACCESS_DOWNLOAD_REPORT = 'quick-access-download-report';
export const QUICK_ACCESS_REQUESTS = 'quick-access-requests';

export const BENEFITS_HOME_TAB = 'benefits-home';

export const ADD_COLLABORATOR_CHOICE = { choice: 'add_collaborator' };
export const REMOVE_COLLABORATOR_CHOICE = { choice: 'remove_collaborator' };
export const ADD_DEPENDENT_CHOICE = { choice: 'add-dependant' };
export const ADD_DEPENDENT_MODAL_CHOICE = { choice: 'add-dependant-modal' };

export const ADD_COLLABORATOR_BY_EMAIL_CHOICE = { method: 'enter-email' };
export const ADD_COLLABORATOR_BY_FILE_CHOICE = { method: 'upload-file' };
export const MICROSOFT_METHOD = { method: 'SSO-MICROSOFT' };
export const GOOGLE_METHOD = { method: 'SSO-GOOGLE' };
export const MANUAL_METHOD = { method: 'MANUAL-CREDENTIALS' };

export const COLLABORATOR_CHOICE_DICT: { [key: string]: { choice: string } } = {
  addCollaborators: ADD_COLLABORATOR_CHOICE,
  deleteSubscriptions: REMOVE_COLLABORATOR_CHOICE,
  addDependents: ADD_DEPENDENT_CHOICE
};

export const COLLABORATOR_UPLOAD_METHOD_CHOICE_DICT: { [key: string]: { method: string } } = {
  uploadByEmail: ADD_COLLABORATOR_BY_EMAIL_CHOICE,
  uploadByFile: ADD_COLLABORATOR_BY_FILE_CHOICE
};

export const FLEXIBLE_BENEFITS_DETAIL = 'flexible_benefits_detail';
export const PLAN = 'plan';
export const WELLBEING_BENEFIT = 'wellbeing_benefit';
export const HEALTH_BENEFIT = 'health_benefit';

export const UPSELLING_TYPES = {
  upgrade_plan: PLAN,
  upgrade_protection: HEALTH_BENEFIT,
  upgrade_benefits: WELLBEING_BENEFIT
};

export const HOME_RF_TABS_DICT: { [key: number]: { tab: string } } = {
  0: { tab: 'last_cycle' },
  1: { tab: 'current_cycle' }
};

export const TABLE_ERROR = { error_message: 'table' };
export const FILE_SIZE_ERROR = { error_message: 'file_size' };
export const FILE_FORMAT_ERROR = { error_message: 'file_format' };
export const GENERIC_ERROR = { error_message: 'error' };

export const TYPE_COURSE = { type: 'course' };
export const TYPE_EDUCATIONAL_MATERIAL = { type: 'educational-material' };

export const TYPE_SELECTED_ALL = { type_selected: 'all' };
export const TYPE_SELECTED_TRAINING = { type_selected: 'training' };
export const TYPE_SELECTED_INSURANCE = { type_selected: 'insurance' };

export const REQUESTS_TYPES = {
  all: TYPE_SELECTED_ALL,
  training: TYPE_SELECTED_TRAINING,
  health: TYPE_SELECTED_INSURANCE
};
